/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Satispay } from "./Satispay";
import * as t from "io-ts";

// required attributes
const RestSatispayResponseR = t.interface({});

// optional attributes
const RestSatispayResponseO = t.partial({
  data: Satispay
});

export const RestSatispayResponse = t.intersection(
  [RestSatispayResponseR, RestSatispayResponseO],
  "RestSatispayResponse"
);

export type RestSatispayResponse = t.TypeOf<typeof RestSatispayResponse>;
